/** Solo dígitos del CUIT, máximo 11 (formato AR típico). */
export function stripCuitDigits(value: string | undefined | null): string {
  return String(value ?? "").replace(/\D/g, "").slice(0, 11);
}

/** Vista `XX-XXXXXXXX-X`; el valor de negocio debe ser `stripCuitDigits`. */
export function formatCuitMask(value: string | undefined | null): string {
  const d = stripCuitDigits(value);
  if (d.length <= 2) return d;
  if (d.length <= 10) return `${d.slice(0, 2)}-${d.slice(2)}`;
  return `${d.slice(0, 2)}-${d.slice(2, 10)}-${d.slice(10, 11)}`;
}
